module.exports = __webpack_public_path__ + "img/eye-icon.f795aff2.svg";